/* MĚNA DAT ANALÝZY + DATA PŘIPRAVENÁ STEJNĚ JAKO NA STRÁNCE ANALÝZY.
 * ============================================================================
 *
 * PROČ TO EXISTUJE (audit 3. 10. 2026, nález A3.2 a A3.3)
 * -------------------------------------------------------
 * Stránka analýzy (pages/AnalyzaV2Page.js) si uložená data před vykreslením
 * PŘIPRAVÍ: `normalizeV2(v2, undefined, menaOrganizace)` dolije výchozí řádky
 * a hlavně PŘEPOČÍTÁ cizoměnné řádky — řádek se starým kurzem se do majetku
 * nezapočítá. A čísla kreslí v MĚNĚ DAT, ne v měně účtu poradce.
 *
 * Tisk analýzy a karta klienta to dělaly po svém:
 *   • tisk počítal ze SYROVÝCH dat, takže řádek v cizí měně se starým kurzem
 *     dal v analýze čisté jmění 3 196 000 a na papíře 3 446 000 (rezerva
 *     4,0× proti 8,5×),
 *   • tisk kreslil symbol MĚNY ÚČTU: stará analýza v korunách se u účtu
 *     přepnutého na Slovensko vytiskla jako „Čisté jmění 2 910 000 €“.
 *
 * PRAVIDLO: kdo ukazuje čísla analýzy MIMO stránku analýzy (tisk, karta
 * klienta, později Návrh a plán), bere data a měnu ODSUD. Druhá kopie
 * téhle logiky by se za půl roku rozešla se stránkou.
 *
 * MĚNA DAT (zrcadlo `menaDatAnalyzy` na stránce):
 *   • analýza s razítkem `base_currency` (CZK/EUR) → ta měna,
 *   • analýza BEZ razítka je z doby korun → CZK a `legacy: true`
 *     (lib/tenantMena.js → menaUlozenychDat). Nepřeznačuje se na měnu účtu.
 * Přepočet mezi měnami se NEDĚLÁ — appka nezná kurz. Jen se kreslí symbol
 * měny, ve které čísla doopravdy jsou.
 *
 * Čisté funkce, žádný React ani síť.
 */
import { normalizeV2 } from "./model";
import { menaZeme, symbolMeny, zakladniMena } from "./meny";
import { menaUlozenychDat } from "@/lib/tenantMena";

const jeObjekt = (v) => !!v && typeof v === "object" && !Array.isArray(v);

/**
 * Měna ORGANIZACE poradce — základ, ze kterého `normalizeV2` doplní měnu
 * analýze bez razítka. Stejný výpočet jako `menaOrganizace` na stránce
 * analýzy: uložená měna účtu, jinak měna podle země, NIKDY podle jazyka.
 * @param {object} user  přihlášený uživatel z /auth/me (useAuth)
 */
export function menaOrganizace(user) {
  return zakladniMena(user?.base_currency || menaZeme(user?.country_code));
}

/**
 * V jaké měně jsou čísla uložené analýzy.
 * @param {object} v2  uložená data analýzy (financial_maps.data.v2)
 * @returns {{ kod: string, symbol: string, legacy: boolean }}
 */
export function menaDat(v2) {
  const { mena, legacy } = menaUlozenychDat(jeObjekt(v2) ? v2 : {});
  return { kod: mena, symbol: symbolMeny(mena), legacy };
}

/**
 * Uložená analýza → data přesně v té podobě, ze které počítá stránka
 * analýzy, plus měna dat.
 *
 * @param {object} v2       uložená data analýzy (financial_maps.data.v2)
 * @param {string} menaOrg  měna organizace poradce (viz `menaOrganizace`)
 * @returns {{ d: object, mena: { kod, symbol, legacy } } | null}
 *          null = analýza neexistuje (nic se nemá tvářit jako nulová data)
 */
export function pripravAnalyzu(v2, menaOrg) {
  if (!jeObjekt(v2)) return null;
  /* Měnu se ptáme na SYROVÝCH datech: normalizeV2 chybějící razítko doplní
     z měny účtu a potom už nejde poznat, jestli tam opravdu bylo. */
  const mena = menaDat(v2);
  return { d: normalizeV2(v2, undefined, menaOrg), mena };
}
